// HavenWorkbench — per-agent wrapper over <CompositionWorkbench> for
// HAVEN, the vulnerability-adaptation-plan composer. HAVEN emits two
// structural variants: light-touch and full-safeguarding.

import CompositionWorkbench from '.';
import { compositionAgentConfig } from './composition-agent-config';
import type { BaseDraft } from '@/data/types';

interface HavenWorkbenchProps {
    draft: BaseDraft;
    readOnly?: boolean;
    onApproved?: (draft: BaseDraft) => void;
    onRejected?: (draft: BaseDraft) => void;
    onRevisionRequested?: (draft: BaseDraft) => void;
}

export default function HavenWorkbench({
    draft,
    readOnly,
    onApproved,
    onRejected,
    onRevisionRequested,
}: HavenWorkbenchProps) {
    return (
        <CompositionWorkbench<BaseDraft>
            agentName="HAVEN"
            draft={draft}
            table={compositionAgentConfig.HAVEN.table}
            actions={compositionAgentConfig.HAVEN.actions}
            readOnly={readOnly}
            onApproved={onApproved}
            onRejected={onRejected}
            onRevisionRequested={onRevisionRequested}
        />
    );
}
